import { transport } from 'config/transport';

export function callApiSaveChiCongDoanVung(congdoanvungId, month, year, body) {
    return transport.post(`/congdoanvung/${congdoanvungId}/thuchi/chicongdoanvung`, body, { params: { month, year } });
}
